export interface IViewFolder {
  id: string;
  name: string;
  tenantId?: string;
  parentId: string | null;
  isFavorite: boolean;
  isDefault: boolean;
  createdOn: Date | string;
  category: ViewCategory;
  children?: IViewFolder[] | null;
  level: number;
  isExpanded?: boolean;
  folderType?: FolderType | null;
  adoFolderId?: string | null;
  temporaryViewID: string | null;
}

export interface ILevelVF {
  id: string;
  name: string;
  parentId: string | null;
  isFavorite: boolean;
  createdOn: Date | string;
  category: ViewCategory;
  children?: IViewFolder[];
  level: number;
  temporaryViewID: string | null;
}

export enum ViewCategory {
  Folder,
  SystemView,
  UserView,
  SharedView,
  SharedWithMe,
}

export enum FolderType {
  User,
  Shared,
  System,
  SharedWithMe,
}

export interface ITreeNodeDetails {
  id: string;
  name: string;
  shortPath: string;
  fullPath: string;
  action: string;
  folderType: string;
}

export interface IViewFolderItem {
  id: string;
  children: Array<object> | null;
}
